import { render, staticRenderFns } from "./paperMedia_list.vue?vue&type=template&id=619027dc&scoped=true"
import script from "./paperMedia_list.vue?vue&type=script&lang=js"
export * from "./paperMedia_list.vue?vue&type=script&lang=js"
import style0 from "./paperMedia_list.vue?vue&type=style&index=0&id=619027dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619027dc",
  null
  
)

export default component.exports